<template>
  <organism-escalation-template
    v-if="filterData"
    :fields="fields"
    :items="escalationList"
    :filter-list="filterData"
    :template-status-option="templateStatusOption"
    @onDeleteTemplate="deleteTemplate"
    @onUpdateFilterData="onUpdateFilterData"
    @onSetDefaultFilterData="onSetDefaultFilterData"
    @onUpdateCurrentPageOrPerPage="onUpdateCurrentPageOrPerPage"
  ></organism-escalation-template>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

import OrganismEscalationTemplate from "@/components/organisms/portal/internal/escalation/OrganismEscalationTemplate.vue"
import {
  deleteTicketEscalation,
  getTicketEscalationList,
} from "@/api/module-1/escalation"
import mixins from "@/mixins"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"

export default {
  name: "EscalationTemplate",
  components: { OrganismEscalationTemplate },
  mixins: [mixins, mixinsObjectHelper],
  data() {
    return {
      fields: [
        {
          key: "status",
          label: "STATUS",
        },
        {
          key: "templateName",
          label: "TEMPLATE NAME",
        },
        {
          key: "description",
          label: "DESCRIPTION",
        },
        {
          key: "ticketAmount",
          label: "APPLIED TICKET",
          class: "text-nowrap",
        },
        {
          key: "deleteAction",
          label: "",
        },
      ],
      escalationList: [],
      filterData: null,
      templateStatusOption: ["Active", "Suspended"],
      modalDelete: "modal-confirm-delete-escalation",
    }
  },

  computed: {
    ...mapGetters("appFilter", ["getInternalEscalationTemplateFilter"]),
  },

  mounted() {
    this.getEscalationList()
  },

  methods: {
    ...mapActions("appFilter", ["setInternalEscalationTemplateFilter"]),

    async deleteTemplate(template) {
      this.showLoading(true)
      await deleteTicketEscalation(template.templateId)
        .then(() => {
          this.$bvModal.hide(this.modalDelete)
          this.toastSuccess("Delete successful")
          this.getEscalationList()
        })
        .catch(() => this.toastError("Delete failed"))
        .finally(() => this.showLoading(false))
    },

    cloneFilterDataFromVuex() {
      const filterDataFromVuex = this.getInternalEscalationTemplateFilter
      this.filterData = this.deepCopyObject(filterDataFromVuex)
    },

    filterDecoration() {
      return {
        pageSize: this.filterData.perPage,
        name: this.filterData.templateName,
        description: this.filterData.description,
        statuses: this.filterData.status.map((item) => item.toUpperCase()),
        pageNumber: this.filterData.currentPage,
      }
    },

    onUpdateFilterData(filter) {
      this.setInternalEscalationTemplateFilter(filter)
      this.getEscalationList()
    },

    onSetDefaultFilterData() {
      const filter = {
        currentPage: 1,
        templateName: "",
        description: "",
        status: [],
        perPage: 10,
        totalCount: 0,
      }
      this.setInternalEscalationTemplateFilter(filter)
      this.getEscalationList()
    },

    async getEscalationList() {
      this.showLoading(true)
      this.cloneFilterDataFromVuex()
      const params = this.filterDecoration()
      await getTicketEscalationList(params)
        .then((response) => {
          this.filterData.totalCount = response.totalCount
          this.setInternalEscalationTemplateFilter({
            ...this.getInternalEscalationTemplateFilter,
            totalCount: response.totalCount,
          })
          this.escalationList = response?.data.map((item) => {
            return {
              templateId: item.escalationId,
              templateName: item.name,
              status: item.status,
              description: item.description,
              ticketAmount: {
                inProgress: item.appliedTicketCount.inProgress,
                all: item.appliedTicketCount.all,
              },
            }
          })
        })
        .finally(() => this.showLoading(false))
    },

    onUpdateCurrentPageOrPerPage(filter) {
      const updatedFilter = {
        ...this.getInternalEscalationTemplateFilter,
        currentPage: filter.currentPage,
        perPage: filter.perPage,
      }
      this.setInternalEscalationTemplateFilter(updatedFilter)
      this.getEscalationList()
    },
  },
}
</script>

<style lang="scss" scoped></style>
